import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

function LinkPage() {
    const params = useParams();
    const navigate = useNavigate();
    const link = params.link;
    useEffect(() => {
        if (!link) {
            return navigate("/files");
        }
        const model_paths = atob(link);
        const json = JSON.parse(model_paths);
        console.log(Array.isArray(json));
        if (Array.isArray(json)) {
            sessionStorage.setItem("model_paths", model_paths);
            return navigate("/viewer");
        }
        return navigate("/files");
    }, []);
    return <></>;
}

export default LinkPage;
